export const GET_RESTAURANT_LIST = 'GET_RESTAURANT_LIST' as const
export const GET_RESTAURANT_LIST_SUCCEEDED = 'GET_RESTAURANT_LIST_SUCCEEDED' as const

export const PURCHASE_RESTAURANT_LIST = 'PURCHASE_RESTAURANT_LIST' as const
export const DESTROY_IMPORTED_RESTAURANT_LIST = 'DESTROY_IMPORTED_RESTAURANT_LIST' as const
